import { Component, OnInit, ElementRef, Input, ViewEncapsulation } from '@angular/core';
import { HangfireRecurringJobService } from '../../services/hangfire-recurring-job.service';
import {
  CreateHangfireRecurringJobDTO,
  HangfireRecurringJobDTO,
} from '../../interfaces/hangfire-recurring-job';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { CreateForm, cronExpressionValidator } from './hangfire-job-dialog.component';
import { MessageService } from 'primeng';
import { Message } from '../../classes/Message';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

@Component({
  selector: 'hangfire-settings',
  templateUrl: './hangfire-settings.component.html',
  providers: [],
})
export class HangfireSettingsComponent implements OnInit {
  public recurringJobs: HangfireRecurringJobDTO[];

  public createVisible: boolean = false;

  public selectedJob: HangfireRecurringJobDTO;

  public scheduleFormControls: { [k: number]: FormControl } = {};

  public pauseEtlQueueDisabled: boolean = false;
  public runJobLoading: boolean = false;

  constructor(
    private hangfireService: HangfireRecurringJobService,
    private messageService: MessageService,
    private http: HttpClient,
    fb: FormBuilder,
  ) {}

  ngOnInit(): void {
    void this.getAllJobs();
  }

  onScheduleEditInit(job: HangfireRecurringJobDTO) {
    this.scheduleFormControls[job.id] = new FormControl<string>(job.cronSchedule, [
      cronExpressionValidator,
    ]);
  }

  async onScheduleEditSave(job: HangfireRecurringJobDTO, index: number) {
    try {
      const value = this.scheduleFormControls[job.id].value;
      await this.hangfireService.updateSchedule(job.id, value);
      await this.getAllJobs();
    } catch (err) {}
  }

  onScheduleEditCancel(job: HangfireRecurringJobDTO, index: number) {
    delete this.scheduleFormControls[job.id];
  }

  async getAllJobs(): Promise<void> {
    this.recurringJobs = await this.hangfireService.getAll();
  }

  async createJob(job: CreateHangfireRecurringJobDTO): Promise<void> {
    await this.hangfireService.create(job);
    await this.getAllJobs();
  }

  onCreateClick() {
    this.createVisible = true;
  }

  async onCreateSubmitted($event: CreateHangfireRecurringJobDTO) {
    await this.createJob($event);
    this.createVisible = false;
  }

  async onDisableClick(job: HangfireRecurringJobDTO) {
    await this.hangfireService.deactivate(job.id);
    await this.getAllJobs();
  }

  async onPauseAlgoETLQueueClick() {
    this.pauseEtlQueueDisabled = true;
    try {
      await this.hangfireService.pauseAlgoEtlQueue();
      this.messageService.add(Message.Success('Pause Request Received', 'Success'));
    } catch (e) {
      this.messageService.add(Message.Error('Could not pause queue', 'Error'));
    } finally {
      this.pauseEtlQueueDisabled = false;
    }
  }

  async onRunClick(job: HangfireRecurringJobDTO) {
    try {
      this.runJobLoading = true;

      const body = new HttpParams().set('jobs[]', job.methodName);

      const options = {
        headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded'),
      };

      await this.http.post(`/hangfire/recurring/trigger`, body.toString(), options).toPromise();

      this.messageService.add(Message.Success('Job Enqueued', 'Success'));
    } catch (e) {
      console.error(e);
      this.messageService.add(Message.Error('Could not enqueue job', 'Error'));
    } finally {
      this.runJobLoading = false;
    }
  }
}
